import {connect} from "react-redux";
import React, {useState} from 'react';
import SearchIcon from "../../../../../assets/SearchIcon";
import {t} from "../../../../../components/Translate";

const styles = {
    unFocusedWrapper: {
        width: '100%',
        height: '100%',
        backgroundColor: 'transient',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        WebkitBoxShadow: '5px 5px 10px 0px rgba(24,62,153,0.13)',
        MozBoxShadow: '5px 5px 10px 0px rgba(24,62,153,0.13)',
        boxShadow: '5px 5px 10px 0px rgba(24,62,153,0.13)',
        borderRadius: '10px'
    },
    focusedWrapper: {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        WebkitBoxShadow: '5px 5px 10px 0px rgba(24,62,153,0.13)',
        MozBoxShadow: '5px 5px 10px 0px rgba(24,62,153,0.13)',
        boxShadow: '5px 5px 10px 0px rgba(24,62,153,0.13)',
        borderRadius: '10px'
    },
    input: {
        border: 'none',
        borderRadius: '10px',
        color: 'black',
        fontSize: '16px',
        padding: '15px',
        width: '100%',
        ':focus': {
            outline: 'none',
        }
    },
    placeholderColor: {
        color: 'white'
    },
    search: {
        border: 'none',
        backgroundColor: 'rgb(4, 62, 92)',
        borderRadius: '10px',
        paddingRight: '10px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
    },
};


const SearchByColumn = ({handleSearch, user, placeholder}) => {

    const [value, setValue] = useState("")

    const search = () => {
        handleSearch(value)
    }

    const handleChange = (event) => {
        setValue(event.target.value)
    }

    return (
        <div
            style={styles.focusedWrapper}
        >
            <div
                style={{
                    color: '#FFFFFF',
                    fontSize: '16px',
                }}
            >
                <input
                    placeholder={t({text: placeholder, user})}
                    value={value}
                    style={styles.input}
                    onChange={handleChange}
                />
            </div>
            <button
                type="button"
                style={styles.search}
                onClick={search}
            >
                <SearchIcon width="20px" height="20px" fill="#fff"/>
            </button>
        </div>
    );
};

SearchByColumn.propTypes = {
};

const mapStateToProps = state => ({
    user: state.user,
});


export default (connect(mapStateToProps)(SearchByColumn))




// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/history/SearchByColumn.jsx